module.exports = "/_next/static/images/bg-phone-1x-8ec1ce340bd7ee93c1d6843c1db8a3f2.png.webp";